class CorUtils {
  constructor() {}

  converterHEXStringemRGBObject(hex) {
    let r = 0,
      g = 0,
      b = 0;
    if (hex.length == 4) {
      r = "0x" + hex[1] + hex[1];
      g = "0x" + hex[2] + hex[2];
      b = "0x" + hex[3] + hex[3];
    } else if (hex.length == 7) {
      r = "0x" + hex[1] + hex[2];
      g = "0x" + hex[3] + hex[4];
      b = "0x" + hex[5] + hex[6];
    }

    return { r, g, b };
  }

  converterRGBObjectemHSLObject(r, g, b) {
    r /= 255;
    g /= 255;
    b /= 255;

    let cmin = Math.min(r, g, b),
      cmax = Math.max(r, g, b),
      delta = cmax - cmin,
      h = 0,
      s = 0,
      l = 0;

    if (delta == 0) {
      h = 0;
    } else if (cmax == r) {
      h = ((g - b) / delta) % 6;
    } else if (cmax == g) {
      h = (b - r) / delta + 2;
    } else {
      h = (r - g) / delta + 4;
    }

    h = Math.round(h * 60);

    if (h < 0) {
      h += 360;
    }

    l = (cmax + cmin) / 2;

    s = delta == 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));

    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);

    return { h, s, l };
  }

  converterHSLObjectParaRGBObject(h, s, l) {
    s /= 100;
    l /= 100;

    const k = (n) => (n + h / 30) % 12;
    const a = s * Math.min(l, 1 - l);
    const f = (n) => l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));

    const r = 255 * f(0);
    const g = 255 * f(8);
    const b = 255 * f(4);
    return { r, g, b };
  }

  converterHSLObjectParaRGBAObject(h, s, l, a = 1) {
    const cores = this.converterHSLParaRGB(h, s, l);

    if (a > 1) {
      a /= 100;
    }

    return { r: cores.r, g: cores.g, b: cores.b, a };
  }

  converterHEXStringParaHSLObject(hex) {
    const rgb = this.converterHEXStringemRGBObject(hex);
    const hsl = this.converterRGBObjectemHSLObject(rgb.r, rgb.g, rgb.b);
    return hsl;
  }

  converterHSLStringParaHSLObject(hsl, removePercentSymbol = true, asNumber = true) {
    let hslTratado = hsl.replace("hsl(", "").replace(")", "");
    if (!!removePercentSymbol) {
      hslTratado = hslTratado.replace("%", "");
    }
    const hslArray = hslTratado.split(",");
    let hslObject = {
      h: hslArray[0],
      s: hslArray[1],
      l: hslArray[2],
    };

    if (!!asNumber) {
      hslObject = hslObject.map((valor) => parseFloat(valor));
    }

    return hslObject;
  }

  converterRGBStringParaRGBObject(rgb, asNumber = true) {
    const rgbTratado = rgb.replace("rgb(", "").replace(")", "");
    const rgbArray = rgbTratado.split(",");
    const rgbObject = {
      r: rgbArray[0],
      g: rgbArray[1],
      b: rgbArray[2],
    };

    if (!!asNumber) {
      hslObject = hslObject.map((valor) => parseFloat(valor));
    }

    return rgbObject;
  }

  converterRGBAStringParaRGBAObject(rgba, asNumber = true) {
    const rgbaTratado = rgba.replace("rgba(", "").replace(")", "");
    const rgbaArray = rgbaTratado.split(",");
    const rgbaObject = {
      r: rgbaArray[0],
      g: rgbaArray[1],
      b: rgbaArray[2],
      a: rgbaArray[3],
    };

    if (!!asNumber) {
      hslObject = hslObject.map((valor) => parseFloat(valor));
    }

    return rgbaObject;
  }

  gerarHSLString(h, s, l, hMod = 0, sMod = 0, lMod = 0) {
    h += hMod;
    s += sMod;
    l += lMod;

    return "hsl(" + h + "," + s + "%," + l + "%)";
  }

  gerarRGBString(r, g, b) {
    return `rgb(${r},${g},${b})`;
  }

  gerarRGBAString(r, g, b, a = 1) {
    return `rgba(${r},${g},${b},${a})`;
  }
}

export const corUtils = new CorUtils();
